import { type ActionItem } from 'shared/ui'
import { type DropsRow } from 'entities/Call/model/DropsRow'
import { type VoicemailDropStore } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop'

export const getVoicemailDropTableActions = (
  item: DropsRow,
  store: VoicemailDropStore
): ActionItem[] => {
  return [
    {
      icon: 'edit',
      text: 'Rename',
      onAction: () => store.onRename(item.id),
    },
    {
      icon: 'close',
      text: 'Remove from the list',
      onAction: () => store.onDelete(item.id),
    },
  ]
}
